import { Line } from 'vue-chartjs'
import chart from '@/mixins/chart'
import Utils from '@/utils/charts'
import options from '@/utils/chart-options/timeBasedLinesBar'
import Colors from '@/utils/chart-options/colors'

export default {
  extends: Line,
  mixins: [chart],
  props: {
    options: {
      type: Object,
      default: () => options
    }
  },
  methods: {
    datasetToChartData (dataset) {
      return {
        labels: dataset.rows.map(e => this.dateLabel(e[0])),
        datasets: [
          {
            label: this.$t('charts.averageTime.label'),
            backgroundColor: Colors[0](this, { light: true }),
            borderColor: Utils.color({ ...Utils.colorValue('primary'), a: 0.5 }),
            borderWidth: 2,
            data: dataset.rows.map(e => e[2] / 60)
          }
        ]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/charts/averageTime.js